import { BUSINESS } from "@/constants/business";

export default function LogoBanner() {
  return (
    <section
      data-testid="logo-banner"
      className="relative w-full overflow-hidden bg-[var(--tt-green-900)]"
    >
      {/* Decorative top strip */}
      <div className="h-2 tape opacity-90" />

      <div className="relative">
        {/* Background radial accents */}
        <div className="absolute inset-0">
          <div className="absolute -top-32 -left-32 w-[520px] h-[520px] rounded-full bg-[var(--tt-orange)] opacity-[0.12] blur-3xl" />
          <div className="absolute -bottom-32 -right-32 w-[620px] h-[620px] rounded-full bg-[var(--tt-green-500)] opacity-[0.18] blur-3xl" />
        </div>
        <div className="absolute inset-0 grain opacity-50" />

        {/* Hex pattern overlay */}
        <div
          className="absolute inset-0 opacity-[0.06]"
          style={{
            backgroundImage:
              "radial-gradient(circle at 1px 1px, white 1px, transparent 0)",
            backgroundSize: "28px 28px",
          }}
        />

        <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-10 sm:py-14 lg:py-16 flex flex-col items-center text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-[var(--tt-orange)]/40 bg-[var(--tt-orange)]/10 text-[var(--tt-orange)] text-[10px] sm:text-xs font-bold uppercase tracking-[0.22em]">
            <span className="w-1.5 h-1.5 rounded-full bg-[var(--tt-orange)] animate-pulse" />
            {BUSINESS.city}
          </div>

          <div className="relative w-full max-w-3xl mt-6">
            {/* Logo glow */}
            <div className="absolute -inset-6 sm:-inset-10 bg-[var(--tt-orange)]/15 blur-3xl rounded-full" />
            <img
              src="/assets/logo-transparent.png"
              alt="Tuncay Ticaret · Hırdavat & Geri Dönüşüm"
              className="relative w-full h-auto object-contain drop-shadow-[0_18px_30px_rgba(0,0,0,0.4)]"
              data-testid="banner-logo"
            />
          </div>

          <p className="relative mt-6 text-[var(--tt-cream)]/80 text-sm sm:text-base font-medium tracking-wide max-w-xl">
            {BUSINESS.address}
          </p>

          {/* phones strip */}
          <div className="relative mt-6 flex flex-wrap items-center justify-center gap-3">
            {BUSINESS.phones.map((p) => (
              <a
                key={p.whatsapp}
                href={`tel:${p.tel}`}
                data-testid={`banner-phone-${p.label.toLowerCase().replace(" ", "-")}`}
                className="inline-flex items-center gap-2 rounded-full bg-white/10 hover:bg-white/15 border border-white/15 text-white text-sm font-bold px-4 py-2 transition-colors backdrop-blur"
              >
                <svg viewBox="0 0 24 24" className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
                {p.display}
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Decorative bottom strip */}
      <div className="h-2 tape opacity-90" />
    </section>
  );
}
